import InternetExplorer from './InternetExplorer';
import Minesweeper from './Minesweeper';
import ErrorBox from './ErrorBox';
import MyComputer from './MyComputer';
import Notepad from './Notepad';
import Winamp from './Winamp';
import Paint from './Paint';
import EmbeddedPage from './EmbeddedPage';
import iePaper from 'assets/windowsIcons/ie-paper.png';
import ie from 'assets/windowsIcons/ie.png';
import mine from 'assets/minesweeper/mine-icon.png';
import error from 'assets/windowsIcons/897(16x16).png';
import computer from 'assets/windowsIcons/676(16x16).png';
import computerLarge from 'assets/windowsIcons/676(32x32).png';
import notepad from 'assets/windowsIcons/327(16x16).png';
import notepadLarge from 'assets/windowsIcons/327(32x32).png';
import winamp from 'assets/windowsIcons/winamp.png';
import paintLarge from 'assets/windowsIcons/680(32x32).png';
import paint from 'assets/windowsIcons/680(16x16).png';

const gen = () => {
  let id = -1;
  return () => {
    id += 1;
    return id;
  };
};
const genId = gen();
const genIndex = gen();
const getAdaptiveWindowSize = (minW, minH, maxW, maxH) => {
  const width = Math.max(minW, Math.min(maxW, window.innerWidth - 120));
  const height = Math.max(minH, Math.min(maxH, window.innerHeight - 130));
  return { width, height };
};
const getCenteredOffset = (size, fallbackX = 120, fallbackY = 24) => ({
  x: Math.max(10, Math.floor((window.innerWidth - size.width) / 2) || fallbackX),
  y: Math.max(10, Math.floor((window.innerHeight - size.height - 32) / 2) || fallbackY),
});
const defaultBrowserSize = getAdaptiveWindowSize(760, 560, 1060, 760);
const defaultBrowserOffset = getCenteredOffset(defaultBrowserSize, 120, 24);
export const defaultAppState = [
  {
    component: Minesweeper,
    header: {
      title: '扫雷',
      icon: mine,
    },
    defaultSize: {
      width: 0,
      height: 0,
    },
    defaultOffset: {
      x: 180,
      y: 170,
    },
    resizable: false,
    minimized: false,
    maximized: false,
    id: genId(),
    zIndex: genIndex(),
  },
];

export const defaultIconState = [
  {
    id: 0,
    icon: ie,
    title: 'Internet Explorer',
    component: InternetExplorer,
    appKey: 'Internet Explorer',
    isFocus: false,
  },
  {
    id: 1,
    icon: mine,
    title: '扫雷',
    component: Minesweeper,
    appKey: 'Minesweeper',
    isFocus: false,
  },
  {
    id: 2,
    icon: computerLarge,
    title: '我的电脑',
    component: MyComputer,
    appKey: 'My Computer',
    isFocus: false,
  },
  {
    id: 3,
    icon: notepadLarge,
    title: '记事本',
    component: Notepad,
    appKey: 'Notepad',
    isFocus: false,
  },
  {
    id: 4,
    icon: winamp,
    title: 'Winamp',
    component: Winamp,
    appKey: 'Winamp',
    isFocus: false,
  },
  {
    id: 5,
    icon: paintLarge,
    title: '画图',
    component: Paint,
    appKey: 'Paint',
    isFocus: false,
  },
];

export const appSettings = {
  'Internet Explorer': {
    header: {
      icon: iePaper,
      title: 'Internet Explorer',
    },
    component: InternetExplorer,
    defaultSize: defaultBrowserSize,
    defaultOffset: defaultBrowserOffset,
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: true,
  },
  Minesweeper: {
    header: {
      icon: mine,
      title: '扫雷',
    },
    component: Minesweeper,
    defaultSize: {
      width: 0,
      height: 0,
    },
    defaultOffset: {
      x: 190,
      y: 180,
    },
    resizable: false,
    minimized: false,
    maximized: false,
    multiInstance: true,
  },
  Error: {
    header: {
      icon: error,
      title: 'C:\\',
      buttons: ['close'],
      noFooterWindow: true,
    },
    component: ErrorBox,
    defaultSize: {
      width: 380,
      height: 0,
    },
    defaultOffset: {
      x: window.innerWidth / 2 - 190,
      y: window.innerHeight / 2 - 60,
    },
    resizable: false,
    minimized: false,
    maximized: false,
    multiInstance: true,
  },
  'My Computer': {
    header: {
      icon: computer,
      title: '我的电脑',
    },
    component: MyComputer,
    defaultSize: {
      width: 660,
      height: 500,
    },
    defaultOffset: {
      x: 260,
      y: 50,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: false,
  },
  Notepad: {
    header: {
      icon: notepad,
      title: '无标题 - 记事本',
    },
    component: Notepad,
    defaultSize: {
      width: 660,
      height: 500,
    },
    defaultOffset: {
      x: 270,
      y: 60,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: true,
  },
  Winamp: {
    header: {
      icon: winamp,
      title: 'Winamp',
      invisible: true,
    },
    component: Winamp,
    defaultSize: {
      width: 0,
      height: 0,
    },
    defaultOffset: {
      x: 0,
      y: 0,
    },
    resizable: false,
    minimized: false,
    maximized: false,
    multiInstance: false,
  },
  Paint: {
    header: {
      icon: paint,
      title: '无标题 - 画图',
    },
    component: Paint,
    defaultSize: {
      width: 660,
      height: 500,
    },
    defaultOffset: {
      x: 280,
      y: 70,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: true,
  },
};

const getCascadeOffset = index => ({
  x: Math.max(20, 120 + (index % 6) * 28),
  y: Math.max(20, 24 + (index % 6) * 22),
});

export const createInternetExplorerApp = ({ url, instanceIndex = 0 }) => ({
  ...appSettings['Internet Explorer'],
  injectProps: {
    homeUrl: url,
  },
  defaultOffset:
    instanceIndex === 0
      ? getCenteredOffset(defaultBrowserSize, 120, 24)
      : getCascadeOffset(instanceIndex),
  multiInstance: true,
});

export const createEmbeddedPageApp = ({ title, url, instanceIndex = 0 }) => ({
  header: {
    icon: iePaper,
    title: title || '网页窗口',
  },
  component: EmbeddedPage,
  injectProps: {
    url,
  },
  defaultSize: getAdaptiveWindowSize(760, 560, 1100, 800),
  defaultOffset:
    instanceIndex === 0
      ? getCenteredOffset(getAdaptiveWindowSize(760, 560, 1100, 800), 120, 24)
      : getCascadeOffset(instanceIndex),
  resizable: true,
  minimized: false,
  maximized: window.innerWidth < 800,
  multiInstance: true,
});

export const createBuiltInDesktopIcons = (startId = 0) =>
  defaultIconState.map((icon, index) => ({
    ...icon,
    id: startId + index,
    order: startId + index + 1,
    actionType: 'app',
    isFocus: false,
  }));

export {
  InternetExplorer,
  Minesweeper,
  ErrorBox,
  MyComputer,
  Notepad,
  Winamp,
  EmbeddedPage,
};
